const RECOVERY_KEY = "foreducator:deploy-recovery:v2";

/** Persist before reloading: a failed deployment must never create a reload loop. */
export function claimDeployRecovery(storage: Pick<Storage, "getItem" | "setItem">, path: string): boolean {
  try {
    if (storage.getItem(RECOVERY_KEY) === path) return false;
    storage.setItem(RECOVERY_KEY, path);
    return true;
  } catch {
    return false;
  }
}

export function recoverStaleAssets(): boolean {
  try {
    if (!claimDeployRecovery(window.sessionStorage, window.location.pathname)) return false;
    window.location.reload();
    return true;
  } catch {
    return false;
  }
}
